import Vue from "vue";

import { Loading } from "element-ui";

import screenfull from "screenfull";

export const screenfullRequest = (element) => {
    if (screenfull.isEnabled) {
        screenfull.request(element);
        return true;
    } else {
        Vue.prototype.$message({
            message: "你的浏览器不支持全屏",
            type: "warning",
        });
        return false;
    }
}

export const screenfullExit = (element) => {
    screenfull.exit();
}

export const servicesLoading = (target, text, lock = true) => Loading.service({
    target: target,//loading需要覆盖的DOM节点
    text: text,
    lock, //同v-loading的修饰符
    // backgroundColor: 'rgba(55,55,55,0.4)',//背景色
    // spinner: 'el-icon-loading',//加载图标
})


// 创建一个a标签，并做点击下载事件
export const downloadFileByUrl = (hrefUrl, fileName) => {
    let a = document.createElement("a");
    a.href = hrefUrl;
    a.download = fileName; // 下载后文件名
    document.body.appendChild(a);
    a.click(); // 点击下载
    document.body.removeChild(a); // 下载完成移除元素
    Vue.prototype.$message({
        message: "下载成功",
        type: "success",
    });
}

export const topMenu = () => {
    return {
        menuName: "主类目",
        id: "0",
    }
}

export const handleRouters = (router) => {
    return new Promise((resolve, Reject) => {
        let res = [];
        if (!router) {
            resolve(res);
        }
        router.forEach(async (v) => {
            let t;
            let handleRouterRes = await handleRouters(v.children);
            if (v.component && v.children && v.children.length > 0) {
                t = {
                    ...v,
                    path: v.path,
                    meta: {
                        ...v.meta,
                        notPage: !v.component
                    },
                    component: { render(c) { return c('router-view') } },
                    redirect: { path: v.path },
                    children: [{
                        ...v,
                        meta: {
                            ...v.meta,
                            notPage: !v.component
                        },
                        component: loadView(v.component || 'de'),
                        children: []
                    }].concat(handleRouterRes)
                }
            } else {
                t = {
                    ...v,
                    meta: {
                        ...v.meta,
                        notPage: !v.component
                    },
                    component: loadView(v.component || "de"),
                };
                if (v.children && v.children.length > 0) {
                    t.children = handleRouterRes;
                }
            }
            res.push(t);
        });
        resolve(res);
    }).then(res => {
        return res;
    }).catch(e => {
        console.error('handleRouters ex ', e)
    });
}


export const loadView = (component) => {
    if (!component) {
        return null;
    }
    if (process.env.NODE_ENV == "development") {
        return (resolve) => require([`@/pages/${component}`], resolve);
    } else {
        // 使用 import 实现生产环境的路由懒加载
        return () => import(`@/pages/${component}`);
    }
}

// 二进制数组 生成文件
export const downloadFileByByte = (data, fileName) => {
    const blob = buildBlobByByte(data);
    downloadFile(blob, fileName);
};

export const buildPdfBlobByByte = (data) => {
    const raw = window.atob(data);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: 'application/pdf' });
};

// 将Base64文件转为 Blob
function buildBlobByByte(data) {
    const raw = window.atob(data);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array]);
}


function downloadFile(blob, fileName) {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    // 此写法兼容可火狐浏览器
    document.body.appendChild(link);
    const evt = document.createEvent("MouseEvents");
    evt.initEvent("click", false, false);
    link.dispatchEvent(evt);
    document.body.removeChild(link);
}

// 判断是否是老板
export const currentUserIsBoss = () => {
    let userInfo = Vue.prototype.$storageUtil.getUserInfo();
    return userInfo && userInfo.userTypeEnum && userInfo.userTypeEnum.Name == 'Boss';
}

// 是否能见进货价：老板和有权限的人可以见
export const currentUserCanSeePrice = () => {
    return currentUserIsBoss() || hasPermi(['commodity:viewretail']);
}

// 获取商品类型type
export const getCommodityMultiSpecMarkType = (value) => {
    if (value) {
        return "primary";
    } else {
        return "warning";
    }
}


// 获取商品在产状态类型
export const getCommodityProductionType = (_enum) => {
    if (!_enum || !_enum.Name) {
        return;
    }
    if (_enum.Name == 'InProduction') {
        return 'success';
    } else if (_enum.Name == 'PartStopProduction') {
        return 'warning';
    } else if (_enum.Name == 'FullStopProduction') {
        return "danger";
    }
}

export const getFundAccountImageSrc = (_enum) => {
    if (!_enum || !_enum.Name) {
        return;
    }
    return require('@/assets/images/fundaccount/' + _enum.Name + '.png')
}

export const shippedMarkText = () => {
    return "发货标识说明<br />" +
        "发货标识所选商品是否已经发货，选项会影响后续单据流程。<br />" +
        "若已发货则会影响所选商品的已出库数量，后续需要创建入库单将已出库商品入库；<br />" +
        "未发货则会影响所选商品的待出库数量，后续无需为商品进行入库操作，自动扣减待出库数量。"
}

export const collectedMarkText = () => {
    return "收款标识说明<br />" +
        "发收款标识所选商品是否已经收款，选项会影响后续单据流程。<br />" +
        "若已收款则会影响所选商品的已收款金额，后续需要创建付款单将已收款的商品退款；<br />" +
        "未收款则会影响所选商品的待收款数量，后续无需为商品进行退款操作，自动扣减待收款数量。"
}

export const warehousedMarkText = () => {
    return '入库标识说明<br />',
        '入库标识所选商品是否已经入库，选项会影响后续单据流程。<br />' +
        '若已入库则会影响所选商品的已入库数量，后续需要创建出库单将已入库商品退回；<br />' +
        '未入库则会影响所选商品的待入库数量，后续无需为商品进行出库操作，自动扣减待出库数量。'
}

export const paidMarkText = () => {
    return '付款标识说明<br />',
        '付款标识所选商品是否已经付款，选项会影响后续单据流程。<br />' +
        '若已付款则会影响所选商品的已付款金额，后续需要创建收款单将已付款的商品收款；<br />' +
        '未付款则会影响所选商品的待付款金额，后续无需为商品进行收款操作，自动扣减待付款金额。'
}

export const needDeliveryText = () => {
    return '配送标识说明<br />',
        '配送标识所选商品是否需要配送，选项会影响后续单据流程。<br />' +
        '若需要配送则需要选择配送员将商品配送入库，配送原则为‘谁送出谁拉回’；<br />' +
        '无需配送则代表无需配送员配送商品'
}


export const openNewPage = (url, type = '_blank') => {
    window.open(url, type)
}

const browser = () => {
    const u = navigator.userAgent
    return {
        edge: u.indexOf('Edge') > -1, // Edge内核
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应用程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === 'qq' // 是否QQ
    }
}

export const hasPermi = (value) => {
    if (value && value instanceof Array && value.length > 0) {
        const all_permission = "*:*:*";
        const permissions = Vue.prototype.$storageUtil.getPermissions() || [];
        const hasPermissions = permissions.some(permission => {
            return all_permission === permission || value.includes(permission)
        })
        return hasPermissions;
    } else {
        throw new Error(`请设置操作权限标签值`)
    }
}

export const getColor = (value) => {
    if (value == 'primary') {
        return 'var(--fm-primary-color)';
    } else if (value == 'success') {
        return 'var(--fm-success-color)';
    } else if (value == 'warning') {
        return 'var(--fm-warning-color)';
    } else if (value == 'danger' || value == 'error') {
        return 'var(--fm-danger-color)';
    } else if (value == 'info') {
        return 'var(--fm-info-color)';
    } else if (value == 'text') {
        return 'var(--fm-regular-text-color)';
    }
}

export const getAmountCapitalization = (n = 0) => {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
};


export const transFundAccountBalanceDetailInvert = (_enum) => {
    if (!_enum || !_enum.Name) {
        return false;
    }
    if (_enum.Name.startsWith('In_')) {
        return false;
    }
    return true;
}

// 加法
export const sum = (list) => {
    if (typeof list == 'undefined' || list.length == 0) {
        return '0.00';
    }
    if (list.length == 1) {
        return toFixedFun(Number(list[0]), 2)
    }
    return toFixedFun(list.reduce(function (prev, curr, idx, arr) {
        return ((Number(prev) * 1000) + (Number(curr) * 1000)) / 1000;
    }), 2)
}

// 加法
export const sumQuantity = (list) => {
    if (typeof list == 'undefined' || list.length == 0) {
        return '0.00';
    }
    if (list.length == 1) {
        return toFixedFun(Number(list[0]), 3)
    }
    return toFixedFun(list.reduce(function (prev, curr, idx, arr) {
        return ((Number(prev) * 1000) + (Number(curr) * 1000)) / 1000;
    }), 3)
}

// 加法
export const add = (val1, val2, fixed = 2) => {
    return toFixedFun((((Number(val1) * 1000) + (Number(val2) * 1000)) / 1000), fixed)
}

// 减法
export const sub = (val1, val2, fixed = 2) => {
    return toFixedFun((((Number(val1) * 1000) - (Number(val2) * 1000)) / 1000), fixed)
}

// 乘法
export const multi = (val1, val2, fixed = 2) => {
    return toFixedFun((((Number(val1) * 1000) * (Number(val2) * 1000)) / 1000000), fixed)
}

// 除法
export const divis = (val1, val2, fixed = 2) => {
    return toFixedFun(((Number(val1) * 1000) / (Number(val2) * 1000)), fixed)
}

// toFixed
export const toFixed = (val1, val2 = 2) => {
    try {
        return Number(val1).toFixed(val2)
    } catch (e) {
        return val1;
    }
}

// 根据属性分组
export const groupBy = (items, key) => {
    return items.reduce(
        (acc, item) => ({
            ...acc,
            [item[key]]: [...(acc[item[key]] || []), item],
        }), {},
    );
}

export const groupByV = (items, key) => {
    let res = groupBy(items, key);
    return Object.values(res);
}

// 解决1.005不会四舍五入 https://developer.aliyun.com/article/1078170
// 重写toFixed
export const toFixedFun = (data, len) => {
    // debugger
    const number = Number(data);
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (len) === 'undefined' || len === 0) {
        return (Math.round(number)).toString();
    }
    let result = number.toString();
    const numberArr = result.split('.');

    if (numberArr.length < 2) {
        // 整数的情况
        return padNum(result);
    }
    const intNum = numberArr[0]; // 整数部分
    const deciNum = numberArr[1];// 小数部分
    const lastNum = deciNum.substr(len, 1);// 最后一个数字

    if (deciNum.length === len) {
        // 需要截取的长度等于当前长度
        return result;
    }
    if (deciNum.length < len) {
        // 需要截取的长度大于当前长度 1.3.toFixed(2)
        return padNum(result);
    }
    // 需要截取的长度小于当前长度，需要判断最后一位数字
    result = `${intNum}.${deciNum.substr(0, len)}`;
    if (parseInt(lastNum, 10) >= 5) {
        // 最后一位数字大于5，要进位
        const times = Math.pow(10, len); // 需要放大的倍数
        let changedInt = Number(result.replace('.', ''));// 截取后转为整数
        changedInt++; // 整数进位
        changedInt /= times;// 整数转为小数，注：有可能还是整数
        result = padNum(`${changedInt}`);
    }
    return result;
    // 对数字末尾加0
    function padNum(num) {
        const dotPos = num.indexOf('.');
        if (dotPos === -1) {
            // 整数的情况
            num += '.';
            for (let i = 0; i < len; i++) {
                num += '0';
            }
            return num;
        } else {
            // 小数的情况
            const need = len - (num.length - dotPos - 1);
            for (let j = 0; j < need; j++) {
                num += '0';
            }
            return num;
        }
    }
}

export const getTenantCommodityMinValue = () => {
    let commodityQuantityDigit = getTenantCommodityQuantityDigit();
    if (commodityQuantityDigit == 0) {
        return 1;
    } else if (commodityQuantityDigit == 1) {
        return 0.1;
    } else if (commodityQuantityDigit == 2) {
        return 0.01;
    } else if (commodityQuantityDigit == 3) {
        return 0.001;
    }
}


export const getTenantCommodityQuantityDigit = () => {
    let tenantSimplifiedPojo = Vue.prototype.$storageUtil.getTenantSimplifiedPojo();
    return Number(tenantSimplifiedPojo.commodityQuantityDigit || 0);
}


// WEBPACK FOOTER //
// ./src/utils/jsTool.js